import { PathType } from '@convergence/types';
import { valueFromTreeAndPath } from './util';
import { AnalysisValueProps } from './types';
import { LabFile } from '../LabFile';

export function AnalysisPath(props: AnalysisValueProps<PathType>) {
  const value = valueFromTreeAndPath(props.tree, props.propertyPath) as
    | {
        isFolder: boolean;
        bucketId?: number;
        path: string;
      }[]
    | undefined;

  if (!value) {
    return (
      <div className="text-red-500">
        Error: No value found at path {props.propertyPath.join('.')}
      </div>
    );
  }

  return (
    <div className="py-2 border-l ">
      <div className="flex flex-col items-center gap-2 ">
        <span className="self-baseline font-bold">{props.name}:</span>
        <ul className="pl-4 self-baseline">
          {value.map((v) => (
            <li>
              {isString(v) ? (
                v
              ) : (
                <LabFile
                  bucketId={v.bucketId!}
                  isFolder={v.isFolder}
                  path={v.path}
                />
              )}
            </li>
          ))}
        </ul>
        {/* {value && value.length > 0 && value.map((v, i) => <SelectedPath path={v.path} onDelete={() => { */}
        {/*     const newValue = [...(value ?? [])] */}
        {/*     newValue.splice(i, 1) */}
        {/* }} />)} */}
      </div>
    </div>
  );
}

function isString(v: unknown): v is string {
  return typeof v === 'string';
}
